var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseScatterChart',{attrs:{"label-x":"Meters of development","compute-function":this.computeMetersOfDevelopment}})}
var staticRenderFns = []

export { render, staticRenderFns }